<div class="breadcrumb-container">
  <ul class="reset">
    <li *ngFor="let breadCrumb of breadCrumbs; let last = last">
      <button class="link" [ngClass]="{'active': last}" [disabled]="!breadCrumb.clickable" (click)="onBreadCrumbClick(breadCrumb)">{{breadCrumb.label}}</button>
      <div class="triangle" *ngIf="!last"></div>
    </li>
  </ul>
</div>
